import styled from '@emotion/styled';

import { mq } from '@hrworks/design-system/utilities';

import { S as SqwLayoutStyles } from '../SqwLayout.styles';

const Header = styled.div(({ theme }) => ({
  gridArea: 'header',
  display: 'flex',
  zIndex: theme.variables.zIndex.header,
  backgroundColor: theme.eclipseTier2Color.surface.raised,
  boxShadow: `0px 1px ${theme.eclipseTier2Color.border.subtle}`,

  [mq.isSmallDevice]: {
    backgroundColor: SqwLayoutStyles.componentConfig(theme).mobileHeaderBackgroundColor,
  },
}));

const HeaderContent = styled.div(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  flex: 1,
  padding: `${theme.eclipseTier1.spacing['12px']} ${theme.eclipseResponsive.margin}`,
  gap: theme.eclipseTier1.spacing['8px'],

  [mq.isSmallDevice]: {
    paddingLeft: 0,
  },

  [mq.conditionalTransition]: {
    transition: `padding ${theme.variables.animationDuration.long}`,
  },
}));

const LeftContainer = styled.div(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.eclipseTier1.spacing['16px'],

  [mq.isSmallDevice]: {
    display: 'none',
  },
}));

const RightContainer = styled.div(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  gap: theme.eclipseTier1.spacing['16px'],
  flex: 1,
}));

export const S = {
  Header,
  HeaderContent,
  LeftContainer,
  RightContainer,
} as const;
